<template>
  <div class="b">
    <Nav current="我的公司"></Nav>
    <div class="titleBox">
      <span class="txt l">角色:</span><span style="color:#ffba1a;">{{titleName}}</span>
      <div class="reviewDetail">
        <el-button
          type="primary"
          size="small"
          class="edit l bgBtn"
          @click="addHandle"
          >添加编号</el-button
        >
        <el-button type="primary" size="small" class="edit l bgBtn"
         @click="exportNumber" >批量导入编号</el-button
        >
        <el-button type="primary" size="small" class="edit l bgBtn" @click="exportData"
          >导出编号</el-button
        >
        
       
        <div></div>
      </div>
    </div>
    <div class="seatch">
      <div><span>编号:</span> <input type="text" v-model="List.name" /></div>
      <div><span>姓名:</span> <input type="text" v-model="List.alias" /></div>
      <div><span>电话:</span> <input type="text" v-model="List.mobile" /></div>
      <div>
        <span>部门:</span> <input type="text" v-model="List.departmentName" />
      </div>
      <div>
        <span>状态:</span>
        <select @change="changeProduct($event)">
          <option></option>
          <option
            v-for="(item, index) in selectList"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
        <span class="el-icon-search" @click="getTableHeight"></span>
      </div>
    </div>

    <div class="el-table-box">
      <el-table
        :data="tableData"
        :empty-text="emptyText"
        style="width: 100%"
        :max-height="tableHeight ? tableHeight : 0"
      >
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          v-for="(col, index) in listCol"
          :key="index"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <div class="link-btn border-right l" @click="editHandle(scope.row)">
              编辑
            </div>
            <div
              class="link-btn l"
              v-show="stopshow(scope.row)"
              @click="outNumber(scope.row)"
            >
              停用
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px ;  text-align: center;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next,jumper"
          :total="total"
          :current-page="currentPage"
          :page-size="pageSize"
          :name="name"
          :page-sizes="[10, 30, 50, 70, 100]"
          @size-change="changePageSize"
          @current-change="changeCurrentSize"
        >
        </el-pagination>
      </div>
    </div>

    <div class="ec_tip none" ref="none">
      <div class="ec-title-out">
        温馨提示 <span id="close" @click="disappear">x</span>
      </div>
      <div class="ec-cont">
        <p>确定要将编号状态停用吗?</p>
        <p>停用后可以将编号继续分配给其他人使用!</p>
      </div>
      <div class="ec-but">
        <input type="button" value="停用" @click="deleHandle" />
        <input class="butOut" type="button" value="放弃" @click="disappear" />
      </div>
    </div>

    <!-- 批量导出弹框 -->
    <div class="ec_tips  exports" ref="export">
      <div class="ec-title">
        批量导入编号 <span id="close" @click="disappears">x</span>
      </div>
      <div class="ec-cont">
        <div class="ec-cont-text">

       <div class="content">
         <p  style="width: 80px;  height: 40px;">选  择  文  件 :</p>
        
        <el-button type="primary" @click="downloadExcel" style="width: 120px;  height: 40px; background: #575fb1;">下载模板文件</el-button>
                    <el-form :model="handleForm" ref="handleForm"  class="demo-dynamic">
                        <el-form-item >
                            <el-input type="file" v-model="fileList.name" placeholder="显示文件名字"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
          </div>
          <div>
          <p class="explain">说<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>明:</p>
          <p class="indent">
            <ul>
              <li>1、支持修改:
                <p>(1) 已经存在的编号可以修改 <span style="color:red;">姓名、部门、角色、备注。</span></p>
                <p>(2) 已经存在的编号可以设置手机号码(之前没有手机号码)。</p>
                <p>(3）可以新增编号(编号必须唯一)，【创建日(倒序)】、【使用者同意日】、【终止日】、【编号id】列不用填写。</p>
              </li>
              <li>2、重点解释:
                <p>(1) 【编号id】有值则认为已经存在的编号。</p>
                <p>(2）系统中的部门存在重复，则修改这个重复部门无效。</p>
              </li>
              <li>3、文件格式: 导入文件只支持.xls为后缀的excel文件。</li>
              <li>4、文件大小: excel文件必须小于5M。</li>
              <li>5、模板限制: <span style="color:red;">批导模板一定要从系统下载，不能使用之前的模板，否则数据不同步。</span>  </li>
            </ul>
          </p>
        </div>
        </div>

        <div class="ec-but">
        <input type="button" value="导入" @click="exporNumber"/>
        <input class="butOut" type="button" value="取消" @click="disappears"/>
        </div>
    </div>
    <!-- 蒙层 -->
    <div class="mask none  exports" ref="none"></div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import axios from "axios";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  // name: "HelloWorld",
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      current: "我的公司",
      handleForm: {
        files: "",
      },
      upLoadBtn: false,
      fileList: [],
      deleteObj: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      titleName:'',
      name: "",
      tableData: [],
      emptyText: "",
      tableHeight: "", //表格高度
      listCol: [
    
        {
          prop: "name",
          label: "编号",
          minwidth: "100",
        },
        {
          prop: "alias", //入库仓库
          label: "姓名",
          minwidth: "100",
        },
        {
          prop: "mobile",
          label: "使用者电话",
          minwidth: "170",
        },
        {
          prop: "status",
          label: "编号状态",
          minwidth: "120",
          ref: "status",
        },
        {
          prop: "departmentName",
          label: "部门",
          minwidth: "150",
          id: "departmentId",
        },
        {
          prop: "remark",
          label: "备注",
          minwidth: "120",
        },
     
      
        {
          prop: "createdAtShow",
          label: "创建日(倒序)",
          minwidth: "120",
        },
        {
          prop: "acceptedAtShow",
          label: "使用者同意日",
          minwidth: "120",
        },
        {
          prop: "stopAtShow",
          label: "终止日",
          minwidth: "120",
        },
      ],
      selectList: [
        { id: 1, name: "待同意" },
        { id: 2, name: "使用中" },
        { id: 3, name: "已拒绝" },
        { id: 4, name: "已停用" },
        { id: 5, name: "已废弃" },
      ],
      statusId: "",
      List: {
        name: "",
        alias: "",
        mobile: "",
        roleName: "",
        status: "",
        departmentName: "",
      },
      switchboard_identity_id:'',
      HncToken:'',
      statusIndex: "",
      exports: [],
    
    };
  },
  mounted() {
    this.statusId = this.$route.query.roleStatus
    this.titleName =this.$route.query.roleName
    this.disabledList = document.getElementsByClassName("none");
    this.getTableHeight();
    this.getHncToken()

  },

  methods: {
     handleRemove(res, file) {
      this.loadingInstance.close();
      this.handleForm.files = file.name;
      console.log(this.handleForm.files)
    },
    handleAvatarError(res, file) {
      this.loadingInstance.close();
      this.$message.error(res.msg);
      console.log("error", res);
    },
    beforeAvatarUpload(file) {
       this.$nextTick(() => {
         this.handleForm.files = "";
      this.loadingInstance = Loading.service({
        fullscreen: true,
        background: "rgba(0, 0, 0, .7)",
      });
        });
      
    },

    getHncToken(){
      let _this = this
      _this.HncToken = this.getCookie("HncToken");
      _this.switchboard_identity_id = this.getCookie("_login_switchboard_identity_id");
      
    },
    //批量导入编号
    exporNumber() {
      let _this = this
      window.open({
        method:'post',
        header:{'Content-Type':'multipart/form-data'},
        url: apiData.importExcel,
        params:{
          HncToken:_this.HncToken,
          switchboard_identity_id:_this.switchboard_identity_id
        }
      }).then(res=>{
          alert(res.data.code)
      })
    },

    exportData() {
      let _this = this
      
      window.open(
        "/api/organizationstructure/switchboardIdentity/excelList?HncToken=" +
          _this.HncToken +
          "&switchboard_identity_id=" +_this.switchboard_identity_id +
         "&name="+ _this.List.name+
         "&alias="+ _this.List.alias+
         "&mobile="+ _this.List.mobile+
         "&roleName="+_this.List.roleName+
         "&departmentName="+_this.List.departmentName+
         "&status="+_this.statusId
        
      );
    },
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      // alert(reg);
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },

    //下载模板
    downloadExcel() {
      axios({
        method: "get",
        header: { "Content-Type": "application/xls" }, // http请求类型
        responseType: "blob", // 返回格式，默认json，可选arraybuffer、blob、document、json、text、stream
        url: apiData.downloadTemplateExcel,
        params: { HncToken: localStorage.getItem("HncToken") },
      })
        .then((res) => {
          //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = "编号模板.xlsx"; // xxx.xls/xxx.xlsx
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        })
        .catch((err) => {
          this.$message.error("服务器连接错误！");
        });
    },

    //批量导入
    exportNumber() {
      let _this = this;
      _this.exports = document.getElementsByClassName("exports");
      console.log(_this.exports, "导入");
      for (let i = 0; i < _this.exports.length; i++) {
        _this.exports[i].style.display = "block";
      }
    },

    stopshow(row) {
      var isshow = false;
      // console.log(row.status);
      switch (row.status) {
        case "已停用":
          isshow = false;
          break;
        default:
          isshow = true;
          break;
      }
      return isshow;
    },
    changePageSize(val) {
      this.pageSize = val;

      this.getTableHeight();
    },
    changeCurrentSize(val) {
      this.currentPage = val;

      this.getTableHeight();
    },

    getTableHeight() {
      let _this = this;
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        this.tableHeight = 500 + "px";
      });
      
      // alert(_this.List.status)
      // console.log()
      let params = {
        name: _this.List.name,
        alias: _this.List.alias,
        mobile: _this.List.mobile,
        roleName: _this.List.roleName,
        status:  _this.statusId,
        departmentName: _this.List.departmentName,
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        roleId:_this.$route.query.id
      };
      http.get(apiData.numberList, true, params, (res) => {
        if (res.data.code == 200) {
          //   _this.$message.success("加载成功");
          _this.tableData = res.data.data.list;
          console.log(_this.tableData);
          for (let i = 0; i < _this.tableData.length; i++) {
            // console.log(_this.tableData[i].status);
            if (_this.tableData[i].status == 5) {
              _this.tableData[i].status = "已废弃";
            } else if (_this.tableData[i].status == 4) {
              _this.tableData[i].status = "已停用";
            } else if (_this.tableData[i].status == 3) {
              _this.tableData[i].status = "已拒绝";
            } else if (_this.tableData[i].status == 2) {
              _this.tableData[i].status = "使用中";
            } else {
              _this.tableData[i].status = "等待同意";
            }

            if (_this.tableData[i].shadowToken) {
              _this.tableData[i].shadowToken = "true";
            } else {
              _this.tableData[i].shadowToken = "false";
            }
          }
          _this.total = res.data.data.totalRow;
        }
      });
      //   console.log(this.tableHeight);
    },
    editHandle(row) {
      let _this = this;
      // console.log(row,'行');
      if (row.status == "已废弃") {
        row.status = 5;
      } else if (row.status == "已停用") {
        row.status = 4;
      } else if (row.status == "已拒绝") {
        row.status = 3;
      } else if (row.status == "使用中") {
        row.status = 2;
      } else {
        row.status = 1;
      }
        this.$router.push({name:'EditNumber',query:{id:row.id,roleId:_this.$route.query.id}})
    },
    outNumber(row) {
      let _this = this;
      _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
      _this.deleteObj = row;
      console.log(_this.disabledList, "停用");
    },
    // 停用编号
    deleHandle() {
      var _this = this;
      console.log(_this.deleteObj);
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
      console.log(_this.disabledList, "停用");
      http.put(apiData.outNumber, true, { id: _this.deleteObj.id }, (res) => {
        if (res.data.code == 200) {
          _this.getTableHeight();
          _this.$message.success("停用成功");
        } else {
          _this.$message.error("停用失败");
        }
      });
    },
    disappears(){
      let _this = this;
      _this.disabledList = document.getElementsByClassName("exports");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
    addHandle() {
       this.$router.push({name:'AddRoleNumber',query:{roleId:this.$route.query.id,name:this.titleName}});
    },
   
    bacthHandle() {
      this.$router.push("/company/bacthRole");
    },

    changeProduct(event) {
      this.statusId = event.target.value; //获取option对应的value值
      
    },

    disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
   
  },
};
</script>
<style scoped lang="less">
.b {
  padding: 0 10px;
}

.titleBox {
  margin: 10px auto;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
display: flex;
  .txt {
    display: inline-block;
    margin-right: 10px;
  }
  .reviewDetail{
    margin-left: 10px;
  }
}
.seatch {
  width: 100%;
  height: 30px;
  div {
    float: left;
    margin-right: 10px;
  }
  input {
    width: 120px;
    height: 30px;
    padding-left: 5px;
    margin-left: 5px;
  }
  select {
    width: 120px;
    height: 30px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .el-icon-search {
    font-size: 20px;
  }
}
.content {
  display: flex;
}
/* 弹框 */
.ec_tip {
  width: 491px;
  height: 247px;
  display: none;
  position: absolute;
  left: 40%;
  top: 300px;
  background: #f8f8f8;
  color: #fff;
  z-index: 99999;
  text-align: center;
}
//批量导入弹框
.ec_tips {
  width: 650px;
  height: 440px;
  display: none;
  position: absolute;
  left: 30%;
  top: 300px;
  background: #f8f8f8;
  color: #fff;
  z-index: 9999;
  font-size: 12px;
  .ec-but {
    margin-left: 100px;
  }

  .ec-cont {
    padding: 20px;
    .indent {
      float: right;
      width: 511px;
      width: -17px 10px 0 0;
      p {
        width: 480px;
        margin-left: 24px;
      }
    }
    .explain {
      width: 80px;
    }
    .el-button {
      margin: -6px 5px 0 17px;
    }
    .el-upload__tip {
      float: right;
    }
  }
}
.ec-cont-text {
  display: flex;
  margin-bottom: 10px;
}
.ec-title-out {
  width: 491px;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
  margin: 0 auto;
   span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
   }
   .ec-but{
     margin: 20;
   }
}
.ec-title {
  width: 650px;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
  margin: 0 auto;
}
.ec-title span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
}

.ec-but {
  position: absolute;
  bottom: 30px;
  margin: 20px;
  display: flex;
}

.ec-but input {
  width: 200px;
  height: 40px;
  margin-left: 20px;
  float: left;
  border-radius: 5px;
  background-color: #fff;
}
.ec-cont {
  padding: 20px 0 0 0px;
  color: #000;
  // display: flex;
  // margin-left: 15px;
  input {
    width: 363px;
    height: 30px;
    padding: 4px 6px 4px 5px;
    border: 1px solid #ccc;
    text-align: center;
  }
  i {
    width: 30px;
    height: 30px;
    font-size: 25px;
    margin-top: 2px;
    display: block;
    margin-left: 5px;
    color: #ccc;
  }
}
.mask {
  width: 100%;
  height: 980px;
  position: absolute;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.butOut {
  border: 1px solid #75c0b6;
  color: #75c0b6;
}
.butOut:hover {
  background: #75c0b6;

  color: #fff;
}
.ec-but input:first-child {
  color: #fff;
  background-color: #75c0b6;
  border: 1px solid #75c0b6;
}

.active {
  background-color: #eee;
}
.demo-dynamic {
  margin: -6px 0 0 10px;
}
</style>